/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './subscribeLabels.defs'
export { main as default } from './subscribeLabels.defs'
